<template>
    <div>
        <modal class="modal-wrapper" :width="width" :height="height" :hideClose="true">
            <template v-slot:content>
            <div class="px-2 py-1 w-full">
                <div class="w-full">
                        <div v-if="currentStepData">
                            <IntakeForm v-if="currentStepData.formTitle" 
                                :steps="formatFormSteps(currentStepData.questions)"
                                :showButton="true"
                                :fieldsToMonitor="fieldsToMonitor(currentStepData.questions)"
                                buttonText="Submit"
                                exitButtonText="Continue Browsing"
                                @hide-modal="hideModal()"
                                @progress="progress()"
                                @submitHandler="(value) => {submitAnonymousLargeFleetLead(value); anonymousLeadSubmissionTracking('mini-pricing-form') ;setInquiryModalSubmitted(true)}"
                            >
                                <template v-slot:content>
                                    <div class="text-center space-bottom-1">
                                        <div class="text-2xl font-bold">{{currentStepData.formHeader}}</div>
                                        <div class="text-base">{{currentStepData.formSubHeader}}</div>
                                    </div>
                                </template>
                            </IntakeForm>
                            <Component
                                v-else
                                :is="getComponent"
                                :step="currentStepData"
                                :showButton="true"
                                @progress="progress()"
                                @back="back()"
                                @hide-modal="hideModal()"
                                @anonymousMonitoringSegment="setSizingSegment"
                                @fleetSize="fleetSizeHandler"
                            >
                            <template v-slot:header-content>
                                <div class="text-center space-bottom-1">
                                    <div class="text-2xl font-bold header-style" v-if="currentStepData.title">{{currentStepData.title}}</div>
                                    <div class="text-base subheader-style" v-if="currentStepData.subTitle">{{currentStepData.subTitle}}</div>
                                </div>
                            </template>
                            <template v-slot:body-content>
                                <div class="font-bold" v-if="currentStepData.bodyHeader">{{currentStepData.bodyHeader}}</div>
                                <div v-if="currentStepData.bodySubHeader">{{currentStepData.bodySubHeader}}</div>
                                <div class="text-center text-base" v-if="currentStepData.bodyText">{{currentStepData.bodyText}}</div>
                            </template>
                            <template v-slot:disclaimer>
                                <div class="align-center" v-if="currentStepData.bodyDisclaimer">
                                    <p class="italic">{{currentStepData.bodyDisclaimer}}</p>
                                </div>
                            </template>
                            <template v-slot:login>
                                <div class="align-center" v-if="currentStepData.login">
                                    <p class="text-center">Already a customer? <a class="text-blue-600" href="https://cloud.samsara.com/webstore">Login</a></p>
                                </div>
                            </template>
                            </Component>
                        </div>
                </div>
            </div>

            </template>
        </modal>
    </div>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex';
    import Modal from '../../utils/modal';
    import vButton from '../../utils/button';
    import ErrorStateIcon from '../../utils/error-state-icon';
    import DOMPurify from 'dompurify';
    import Radio from "./Radio.vue"
    import Information from "./Information.vue"
    import { analyticsTrack } from "../../../../bundled_js/analytics_wrapper";
    import IntakeForm from './IntakeForm.vue'
    import DropdownCheckbox from './DropdownCheckbox.vue'
    import { WebstoreResources } from '../../../mixins/webstore-resources';
    import { getByContentType } from "../../../plugins/contentful"
    import Resize from "../webstore/mixins/resizeMixin"
    export default {
        
        mixins: [WebstoreResources, Resize],
        components: {Modal, vButton, ErrorStateIcon, Radio, IntakeForm, DropdownCheckbox},

        data() {
            return {
                windowWidth: window.innerWidth,
                currentStep: 0,
                formSteps: [],
                segment: "",
                sizingSegmentFlow: "",
                smallFleetSegments: ['1-2', '3-10', '1-10']
            };
        },

        computed: {
            ...mapGetters('webstoreForm', ['businessUnit']),
            width() {
                return this.windowWidth > 550 ? '500px' : '90%';
            },
            height() {
                return this.windowWidth > 550 ? 'auto' : '60%';
            },
            getComponent() {
                const components = {
                    radio: Radio,
                    informational: Information,
                    dropdowncheckbox: DropdownCheckbox
                };
                return components[this.currentStepData.type];
             },
             doFormStepsExist(){
                return this.formSteps.length !== 0;
            },
            currentStepData() {
                if(!this.doFormStepsExist){
                    return false;
                }
                return this.formSteps[this.currentStep]; 
            },
        },

        methods: {

            ...mapMutations('checkout', [
                'setSmallFleetOpportunity',
                'setIsENT'
            ]),

            ...mapMutations([
                'setAnonymousLargeFleet',
                'setPricingModalComplete'
                ]
            ),
            ...mapMutations('webstoreForm', 
                ['setFleetSize', 
                'setBusinessUnit', 
                'setInquiryModalSubmitted'
                ]),

            progress() {
                this.next();
                if(this.currentStep == this.formSteps.length){
                    this.hideModal();
                }
            },
            next() {
                this.currentStep++;
                while(this.currentStep < this.formSteps.length){
                    if(this.formSteps[this.currentStep].flow === this.segment || this.formSteps[this.currentStep].flow === this.sizingSegmentFlow || this.formSteps[this.currentStep].flow === 'standard'){
                        return;
                    }
                    this.currentStep++;
                }
            },
            back() {
                this.currentStep--;
                while(this.currentStep >= 0){
                    if(this.formSteps[this.currentStep].flow === this.segment || this.formSteps[this.currentStep].flow === this.sizingSegmentFlow || this.formSteps[this.currentStep].flow === 'standard'){
                        return;
                    }
                    this.currentStep--;
                }
            },
            hideModal() {
                this.setPricingModalComplete();
                this.$emit('hide-modal')
            },

            onResize() {
                this.windowWidth = window.innerWidth;
            },

            keyUpHandler(e, input) {
                this[`${input}`] = DOMPurify.sanitize(e.target.value);
            },
            formatFormSteps(formQuestions) {
                return formQuestions.map((step) => step.fields)
            },
            fieldsToMonitor(formFields){
                let fields = []
                for(let i = 0; i < formFields.length; ++i){
                    fields.push(formFields[i]?.fields?.name)
                }
                return fields;
            }, 

            setSizingSegment(values){
                if (values.includes('Fleets')){
                    this.sizingSegmentFlow = 'A';
                } 
                else if(values.length == 1 && values[0] === 'Equipment'){
                    this.sizingSegmentFlow = 'B';
                }
                else{
                    this.sizingSegmentFlow = 'C';
                }
                this.setBusinessUnit(values)
            },
            
            filterFormSteps(journey){
                this.formSteps = this.formSteps.filter(
                    (step) => step.flow.includes(journey) || step.flow === "Standard"
                );
                this.currentStep = 0;
            },
            
            fleetSizeHandler(value){
                this.setFleetSize(value);
                if(this.smallFleetSegments.includes(value) && (this.businessUnit.includes('Fleets') || this.businessUnit.length === 1 && this.businessUnit[0] === 'Equipment')){
                    this.segment = 'smallFleet'
                }
                else{
                    this.segment = 'largeFleet'
                }
                this.setAnonymousLargeFleet(this.segment === 'largeFleet')
                this.setSmallFleetOpportunity(this.segment === 'smallFleet')
                analyticsTrack('Filling mini-pricing form', {'customer_type': this.segment})
            }
        },
        
        async created(){
            const form = await getByContentType("anonymousPricingForm", "en-US", {include : 10, "fields.formTitle": "Mini-Pricing Form"});
            this.formSteps = this.formatFormSteps(form.questions);
        },
        
        mounted() {
            this.resize()
        },

        beforeDestroy() {
            window.removeEventListener('resize', this.onResize);
        }

    };
</script>

<style scoped>
    .inquire-wrapper {
        width: 100%;
    }

    .inquire-wrapper hr {
        width: 150%;
        margin-left: -30%;
    }

    .inputs-wrapper {
        padding: 20px;
        padding-bottom: 0px;
        padding-right: 10px;
        width: 100%;
    }

    .inputs-wrapper input {
        padding: 5px 10px;
    }

    .confirmation {
        padding: 30px;
        padding-bottom: 0px;
        padding-right: 10px;
        padding-top: 10px;
        width: 100%;
    }

    .confirmation p {
        font-weight: 400;
        font-size: 16px;
        line-height: 140%;
        color: #00263E;
    }

    .input-wrapper {
        margin-bottom: 20px;
        font-size: 16px;
    }

    .input-wrapper label {
        font-size: 16px;
        font-weight: 500;
    }

    .input-wrapper textarea {
        width: 100%;
        border: 1px solid #B2BFC7;
        border-radius: 4px;
        height: 100px;
        padding: .5rem;
    }

    .inquire-wrapper ::v-deep .rounded-full { 
        border-radius: 30px;
        padding: 5px 30px;
        max-width: 130px !important;
    }

    .modal-wrapper ::v-deep .close {
        width: 18px !important;
        height: 18px !important;
        top: 3px;
        left: 90%;
    }

    .modal-wrapper ::v-deep .close:before {
        height: 18px !important;
    }

    .modal-wrapper ::v-deep .close:after {
        height: 18px !important;
    }

    #modal-title {
        font-size: 24px;
        padding: 3px 30px;
        padding-bottom: 10px;
        text-align: left;
    }

    #element{
        box-sizing: border-box;
        border: 1px solid #A7B2BE;
        border-radius: 24px;
    }

    .header-style{
        padding-bottom: 3px;
    }

    .subheader-style{
        line-height: 1.4rem
    }
</style>
